import { Plus } from "lucide-react";

/**
 * Floating Action Button for quick-create on mobile (one-handed field use).
 * Hidden on desktop (lg:hidden) where the header action buttons are used.
 * Sits above the mobile bottom navigation bar + iOS safe area.
 */
export const MobileFab = ({ onClick, label, icon: Icon = Plus, testid = "mobile-fab" }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className="lg:hidden fixed right-4 bottom-[calc(4rem+1rem+env(safe-area-inset-bottom))] z-40 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 flex items-center justify-center active:scale-95 transition-transform"
    data-testid={testid}
  >
    <Icon className="w-6 h-6" strokeWidth={2.2} />
  </button>
);

export default MobileFab;
